import { Box, Button, Link, List, ListItem, Stack, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FC, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
	minimal?: boolean;
};

const Footer: FC<Props> = ({ minimal }) => {
	const theme = useTheme();
	const nav = useNavigate();

	const handleLinkClick = (path: string) => (event: MouseEvent) => {
		event.preventDefault();
		nav(path);
	};
	
	return (
		<Box component="footer" sx={{ mt: minimal ? 2 : 4, borderTopStyle: 'solid', borderTopWidth: 1, borderTopColor: theme.palette.divider, pt: minimal ? 0 : 2 }}>
			<Grid container rowSpacing={3}>
				{!minimal && (
					<>
						<Grid size={{ xs: 6, sm: 6, md: 4, lg: 4, xl: 4 }}>
							<List>
								<ListItem>
									<Typography variant="body2" color="textSecondary" fontWeight="bold">Free Music</Typography>
								</ListItem>
								<ListItem>
									<Link href="/">Home</Link>
								</ListItem>
								<ListItem>
									<Link href="" onClick={handleLinkClick('/tunes')}>All Music</Link>
								</ListItem>
								<ListItem>
									<Link href="" onClick={handleLinkClick('/albums')}>Albums</Link>
								</ListItem>
								<ListItem>
									<Link href="" onClick={handleLinkClick('/about')}>About the Composer</Link>
								</ListItem>
							</List>
						</Grid>
						<Grid size={{ xs: 6, sm: 6, md: 4, lg: 4, xl: 4 }}>
							<List>
								<ListItem>
									<Typography variant="body2" color="textSecondary" fontWeight="bold">Help</Typography>
								</ListItem>
								<ListItem>
									<Link href="" onClick={handleLinkClick('/faq')}>FAQ</Link>
								</ListItem>
								{/* <ListItem>
									<Link href="/licensing">Licensing Info</Link>
								</ListItem> */}
								<ListItem>
									<Link href="" onClick={handleLinkClick('/youtube')}>YouTube Content ID Claim</Link>
								</ListItem>
								<ListItem>
									<Link href="" onClick={handleLinkClick('/contact')}>Contact</Link>
								</ListItem>
							</List>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
							<Stack spacing={2} py={2}>
								<Typography variant="body2" color="textSecondary" fontWeight="bold">Donations</Typography>
								<Typography variant="body1" color="textPrimary">
									Your donations help me keep the music free for everyone. Thank you!
								</Typography>
								<Button variant="contained" href="https://paypal.me/timkuligfreemusic">Donate</Button>
							</Stack>
						</Grid>
					</>
				)}
				<Grid size={12}>
					<Stack direction="row" sx={{ justifyContent: 'space-between', borderTopWidth: 1, borderTopStyle: 'solid', borderTopColor: theme.palette.divider, paddingY: 2 }}>
						<Typography variant="caption" color="textSecondary">
							&copy; {new Date().getFullYear()} Tim Kulig Free Music. All rights reserved.
						</Typography>
						{/* <Typography variant="caption" color="textSecondary">
							Built with 🧡 by <Link href="https://michellepolan.com" target="_blank">Michelle Polan</Link>.
						</Typography> */}
					</Stack>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Footer;